import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';

@Component({
    selector: 'app-switcher',
    templateUrl: './switcher.component.html',
    styleUrls: ['./switcher.component.scss']
})
export class SwitcherComponent
{
    @Input() switchList: Array<{ switchName: string, isSwitchActive: boolean, [key: string]: any }>;
    @Output() switched = new EventEmitter<{ switchName: string, isSwitchActive: boolean, [key: string]: any }>();
    @Input() theme: "primary" | "grey" = "primary";
    @Input() mods: Array<"--no-border" | "--vertical" | "--xs"> = [];

    @HostBinding('attr.class') get classes()
    {
        return this.theme + " " + this.mods.join(' ');
    }

    constructor() { }

    toggle(type: { switchName: string, isSwitchActive: boolean, [key: string]: any }, index: number)
    {
        if (this.switchList.findIndex(item => item.isSwitchActive) !== index) {
            this.switchList = this.switchList.map((item, i) => ({ ...item, isSwitchActive: index === i } ));
            this.switched.emit(type);
        }
    }
}
